import { render, staticRenderFns } from "./ComplianceAssessmentAI.vue?vue&type=template&id=0d5011af"
import script from "./ComplianceAssessmentAI.vue?vue&type=script&lang=js"
export * from "./ComplianceAssessmentAI.vue?vue&type=script&lang=js"
import style0 from "./ComplianceAssessmentAI.vue?vue&type=style&index=0&id=0d5011af&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports